export default __webpack_public_path__ + "static/media/Ellipse18.e59fb220.png";